import marka from '@components/search/inputs/markaHeavy'
import model from '@components/search/inputs/modelHeavy'
import typ from '@components/search/inputs/typHeavy'
// import typMulti from '@components/search/inputs/typTruckMultiple'
import cena from '@components/search/inputs/cena'
import rata from '@components/search/inputs/rata'
import stan from '@components/search/inputs/stan'
import przebieg from '@components/search/inputs/przebieg'
import rocznik from '@components/search/inputs/rocznik'
import lokalizacja from '@components/search/inputs/lokalizacjaZasieg'
import szukaj from '@components/search/inputs/szukaj'

import krajPochodzenia from '@components/search/inputsAdvanced/krajPochodzenia'
import stanPojazdu from '@components/search/inputsAdvanced/stanPojazdu'
import silnikNaped from '@components/search/inputsAdvanced/silnikNapedSamochody'
import rodzajSprzedazy from '@components/search/inputsAdvanced/rodzajSprzedazy'
import nadwozie from '@components/search/inputsAdvanced/nadwozieCiezarowy'
import dodatkoweWyposazenie from '@components/search/inputsAdvanced/dodatkoweWyposazenieCiezarowe'

const heavyFormInputs = [
    marka,
    cena,
    stan,

    model,
    rata,
    przebieg,

    typ,
    rocznik,
    lokalizacja,
]

const heavyAdvancedInputs = [
    krajPochodzenia,
    stanPojazdu,
    silnikNaped,
    rodzajSprzedazy,
    nadwozie,
    dodatkoweWyposazenie,
]

const heavyFormInputsMobile = [
    marka,
    model,
    typ,
    rocznik,
    cena,
    { type: 'blank' },
]

const heavyAdvancedInputsMobile = [
    lokalizacja,
    stan,
    szukaj,
    przebieg,
    ...heavyAdvancedInputs,
]

export {
    heavyFormInputs,
    heavyAdvancedInputs,
    heavyFormInputsMobile,
    heavyAdvancedInputsMobile,
}